// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2dd3e47","453":"1407b060","732":"63242b32"}[chunkId] + ".chunk.js";
};